import { render, staticRenderFns } from "./TransactionsUser.vue?vue&type=template&id=aa5b854c&scoped=true&"
import script from "./TransactionsUser.vue?vue&type=script&lang=ts&"
export * from "./TransactionsUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5b854c",
  null
  
)

export default component.exports